import { axios } from '../../utils/apiUtils';
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { getAxiosConfig } from '../../utils/apiUtils';
import Experience from '../../components/experience';
import commonStyles from '../../common';
import { Col, Container, ListGroup, Modal, Row} from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown'
import seasonIcon from '../../assets/images/icono-Estacion-titulo.svg';
import storiesIcon from '../../assets/images/Cuentos.svg';
import puppetsIcon from '../../assets/images/stories-puppets.svg';
import songsIcon from '../../assets/images/songs.svg';
import poemsIcon from '../../assets/images/poetry.svg';
import meetIcon from '../../assets/images/Conozcamos.svg';
import craftsIcon from '../../assets/images/Manualidades.svg';
import workshopsIcon from '../../assets/images/Talleres.svg';
import gamesIcon from '../../assets/images/Juegos.svg';
import othersIcon from '../../assets/images/Otros.svg';
import searchIcon from '../../assets/images/search-results.svg';

import { Redirect } from 'react-router';
import { isAllowedToPlayVideo } from '../../utils/authUtils';

const icons = {
  stories: storiesIcon,
  puppets: puppetsIcon,
  songs: songsIcon,
  poems: poemsIcon,
  meet: meetIcon,
  crafts: craftsIcon,
  workshops: workshopsIcon,
  games: gamesIcon,
  others: othersIcon,
  search: searchIcon,
}

const colors = {
  stories: '#689df5',
  puppets: '#555555',
  songs: '#6c76f8',
  poems: '#618157',
  meet: '#f6c7e7',
  crafts: '#a36abe',
  workshops: '#e2cb4b',
  games: '#d48864',
  others: '#9ec0fa',
  search: '#8c8c8c',
}

const styles = {
  welcomeBar: {
    marginLeft: '15px',
    marginRight: '15px',
  },
  header: {
    backgroundColor: '#f0f2f5',
    marginTop: '32px',
    marginBottom: '32px',
  },
  title: {
    ...commonStyles.chungungoH1,
    color: 'darkOrange',
  },
  icon: {
    verticalAlign: 'middle',
    height: '42px',
  }
};

const filtersHTML = [
  {
    title: 'Nivel de Edad',
    options: 
      [{
        value: 'lvl01',
        content: 'A partir de los 2-3 años',
        dataFilter: 'ageLvl',
      },
      {
        value: 'lvl02',
        content: 'A partir de los 3-4 años',
        dataFilter: 'ageLvl',
      },
      {
        value: 'lvl03',
        content: 'A partir de los 4-6 años',
        dataFilter: 'ageLvl',
      },
      {
        value: 'all',
        content: 'Para todas las edades',
        dataFilter: 'ageLvl',
      }]
  },
  {
    title: 'Acciones',
    options: 
      [{
        value: 'listen',
        content: 'Escuchar',
        dataFilter: 'actions',
      },
      {
        value: 'create',
        content: 'Crear',
        dataFilter: 'actions',
      },
      {
        value: 'move',
        content: 'Moverse',
        dataFilter: 'actions',
      },
      {
        value: 'look',
        content: 'Mirar',
        dataFilter: 'actions',
      },
      {
        value: 'sing',
        content: 'Cantar',
        dataFilter: 'actions',
      },
      {
        value: 'think',
        content: 'Pensar',
        dataFilter: 'actions',
      },
      {
        value: 'express',
        content: 'Expresar',
        dataFilter: 'actions',
      }]
  },
  {
    title: 'Temas',
    options: 
      [{
        value: 'mammals',
        content: 'Mamíferos',
        dataFilter: 'topics',
      },
      {
        value: 'birds',
        content: 'Aves',
        dataFilter: 'topics',
      },
      {
        value: 'insects',
        content: 'Insectos',
        dataFilter: 'topics',
      },
      {
        value: 'reptiles',
        content: 'Reptiles',
        dataFilter: 'topics',
      },
      {
        value: 'flora',
        content: 'Flora',
        dataFilter: 'topics',
      },
      {
        value: 'specials',
        content: 'Especiales',
        dataFilter: 'topics',
      },
      {
        value: 'tutorials',
        content: 'Tutoriales & Ayuda',
        dataFilter: 'topics',
      }]
  },
  {
    title: 'Núcleos de Aprendizaje',
    options: 
      [{
        value: 'not',
        content: 'Comunicación Integral',
        subtitle: true,
      },
      {
        value: 'verbal',
        content: 'Lenguaje Verbal',
        dataFilter: 'comprehensive',
      },
      {
        value: 'artistic',
        content: 'Lenguajes Artísticos',
        dataFilter: 'comprehensive',
        lastOne: true,
      },
      {
        value: 'not2',
        content: 'Desarrollo Emocional y Social',
        subtitle: true,
      },
      {
        value: 'identity',
        content: 'Identidad y Autonomía',
        dataFilter: 'develop',
      },
      {
        value: 'coexistence',
        content: 'Convivencia y Ciudadanía',
        dataFilter: 'develop',
      },
      {
        value: 'movement',
        content: 'Corporal y Movimiento',
        dataFilter: 'develop',
        lastOne: true,
      },
      {
        value: 'not3',
        content: 'Interacción y Comprensión del Entorno',
        subtitle: true,
      },
      {
        value: 'exploration',
        content: 'Exploración del Entorno Natural',
        dataFilter: 'environment'
      },
      {
        value: 'understanding',
        content: 'Comprensión del Entorno Sociocultural',
        dataFilter: 'environment'
      },
      {
        value: 'mathinking',
        content: 'Pensamiento Matemático',
        dataFilter: 'environment'
      }]
  },
]

const Category = (props) => {
  const { t } = useTranslation();
  const [experiences, setExperiences] = useState([]);
  const [goToSubscription, setGoToSubscription] = useState(false);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [goToExperience, setGoToExperience] = useState();
  const [seasons, setSeasons] = useState([]);
  
  const [filterTags, setFilterTags] = useState([]);
  const [dropdownClicked, setDropDownClicked] = useState('dropdown-item not');
  const [values, setValues] = useState([]);

  const filtersClick = (event) => {
    const temp = [...filterTags];
    const values = temp.map(tem => tem.value);
    const val = {value: event.target.getAttribute('value'), content: event.target.innerText, dataFilter: event.target.getAttribute('data-filter')};
    if (temp.some( tem => tem.content == val.content )){
      temp.map((item, i) => {
        if (item.content == val.content)
        temp.splice(i,1);
        setFilterTags([...temp]);
        setValues([...values]);
      })
    }
    else {
      setFilterTags(filterTags => [...filterTags, val]);
      setValues(values => [...values, val.value]);
    }
    //console.log(filterTags);
    //console.log(values);
    event.persist();
  }

  const refreshFilterList = () => {
    let texto = '';
    // if there is at least one filter
    if (values.length >= 1) {
      filterTags.map((filter) => {
        if(texto === ''){
          texto = `${texto}${filter.dataFilter}=${filter.value}`;
        } else {
          texto = `${texto}&${filter.dataFilter}=${filter.value}`;
        }
      })
    }
      // no category + no filters, only blank search
      if (props.searchBy == '' && props.filterBy == 'search' && values.length === 0){
        return setExperiences([]);
      }

      let url = `${process.env.REACT_APP_API_URL}/filters/filteredBy?${texto}`;

      // filters + search
      if (props.searchBy && props.searchBy.trim() !== '') {
        url = `${process.env.REACT_APP_API_URL}/filters/filteredBy?${texto}&search=${props.searchBy}`;
      }
      // search without filters
      if (props.searchBy && props.searchBy.trim() !== '' && filterTags.length === 0) {
        url = url = `${process.env.REACT_APP_API_URL}/filters/filteredBy?search=${props.searchBy}`;
      }
      // filters + category
      if (props.filterBy !== 'search' && filterTags.length >= 1) {
        url = `${process.env.REACT_APP_API_URL}/filters/filteredBy?${texto}&category=${props.filterBy}`
        console.log(url);
      }
      // category withou filters
      if(props.filterBy !== 'search' && filterTags.length === 0) {
        url = `${process.env.REACT_APP_API_URL}/filters/filteredBy?category=${props.filterBy}`;
      }
      axios.get(
        url,
        {
          ...getAxiosConfig(),
        },
      )
        .then((filterResponse) => {
          setExperiences(filterResponse.data);
        })
        .catch(console.error);
  };

  useEffect(() => {
    refreshFilterList();
  }, [
    filterTags,
    props
  ]);

  const getFilters = () => {
    setFilterTags([]);
  }
  useEffect(() => {
      getFilters();
  }, [
    props.filterBy
  ]);


  const refreshSeasonsList = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/seasons/complete_list`,
      {
        ...getAxiosConfig(),
      },
    )
      .then((seasonsResponse) => {
        setSeasons(seasonsResponse.data);
      })
      .catch(console.error);
  };

  useEffect(
    () => {
      refreshSeasonsList();
    },
    []
  );

  if (goToExperience) {
    return (<Redirect to={`/experiences/${goToExperience}`} push />);
  }

  if (goToSubscription) {
    return <Redirect to="/account/subscribe/confirm" push />
  }

  return (
    <>
      {props.filterBy !== 'search' &&
        <section class="info-relevante">
          <div class="container">
            <div class="row pt-5">
              <div class="breadcrumb1 col-12">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb p-0">
                    <li class="breadcrumb-item"><a href="/seasons">HOME</a></li>
                    <li class="breadcrumb-item active" aria-current="page">
                      {t(`category.types.${props.filterBy}`).toUpperCase()}
                    </li>
                  </ol>
                </nav>
              </div>
              <div class="col-12 caj-Titulo-Principal">
                <span class="icon-headline-1 search-results">
                  <img
                    src={icons[props.filterBy]} alt="" />
                </span>
                <h1 class="headline-1">{t(`category.types.${props.filterBy}`)}</h1>
              </div>
            </div>
          </div>
          
        </section>
      }

      {props.filterBy === 'search' &&
        <section class="pt-4 pb-4">
          <div class="container">
            <div class="row">
              <div class="breadcrumb1 col-12">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb p-0">
                    <li class="breadcrumb-item"><a href="/seasons">HOME</a></li>
                    <li class="breadcrumb-item active" aria-current="page">RESULTADO DE BÚSQUEDA</li>
                  </ol>
                </nav>
              </div>
              <div class="col-12 align-self-start caj-Titulo-Principal px-3">
                <h1 class="headline-1">resultados de búsqueda</h1>
              </div>
              {props.searchBy !== '' &&
                <div class="col-12">
                  {experiences.length > 0 &&
                    <p>Encontramos las siguientes estaciones con <strong>{props.searchBy}</strong>.</p>
                  }
                  {experiences.length === 0 &&
                    <p>No encontramos nada relacionado con <strong>{props.searchBy}</strong>.</p>
                  }
                </div>
              }
              {props.searchBy === '' &&
                <div class="col-12">
                  <p>Además de nuestras Categorías del Menú, puedes usar los filtros para encontrar Experiencias según tus intereses.</p>
                </div>
              }
            </div>
          </div>
        </section>
      }
      <Modal
        show={showSubscribeModal}
        onHide={evt => setShowSubscribeModal(false)}
      >
        <div class="modal-content">
          <div class="modal-body">
            <h5 class="modal-title mb-3" style={{ color: '#692700' }}>
              {t('subscription.modal_onlysubscribers.title')}
            </h5>
            <p>
              {t('subscription.modal_onlysubscribers.message')}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-link" onClick={evt => setShowSubscribeModal(false)}>
              {t('subscription.modal_onlysubscribers.close')}
            </button>
            <button type="button" class="btn btn-outline-success" onClick={evt => setGoToSubscription(true)}>
              {t('subscription.modal_onlysubscribers.subscribe')}
            </button>
          </div>
        </div>
      </Modal>


      <section class="container filters mb-4">
                    <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="filter-title col-12">
                      <p class="left">Filtrar por:</p>
                      {filterTags.length >= 1 &&
                      <p class="right">Limpiar filtros <span className="close-btn" onClick={()=> setFilterTags([])}>X</span></p>
                      }
                  </div>
                </div>
                {
                  filtersHTML.map((filter) => (
                    <Dropdown>
                      <Dropdown.Toggle size="sm" variant="success" id="dropdown-basic" className="filter-input">
                        {filter.title}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {
                          filter.options.map((option) => (
                            option.subtitle ?
                            (<Dropdown.Header key={option.content}>{option.content}</Dropdown.Header>)
                            : option.lastOne ?
                              filterTags.some( tag => tag.content == option.content) ?
                                ([<Dropdown.Item key={option.content} data-filter={option.dataFilter} className={dropdownClicked} as="li" value={option.value} onClick={filtersClick}>{option.content}</Dropdown.Item>,<Dropdown.Divider />])
                                :
                                ([<Dropdown.Item key={option.content} data-filter={option.dataFilter} as="li" value={option.value} onClick={filtersClick}>{option.content}</Dropdown.Item>,<Dropdown.Divider />])
                              : filterTags.some( tag => tag.content == option.content) ?
                                (<Dropdown.Item key={option.content} data-filter={option.dataFilter} className={dropdownClicked} as="li" value={option.value} onClick={filtersClick}>{option.content}</Dropdown.Item>)
                                :
                                (<Dropdown.Item key={option.content} data-filter={option.dataFilter} as="li" value={option.value} onClick={filtersClick}>{option.content}</Dropdown.Item>)
                          ))
                        }
                      </Dropdown.Menu>
                    </Dropdown>
                  ))
                }
              </div>
              {filterTags.length >= 1 &&
                <div className="filters-tags col-12">
                  {filterTags.map((filter, i) => (
                    <span key={i} value={filter.value} data-filter={filter.dataFilter} onClick={filtersClick}>{filter.content}</span>
                  ))}
                </div>}
            </div>
      </section>

      <section class="actividad">
        <div class="container">
          <div class="row">
            {experiences.map((experience) => (
              <Experience experience={experience} seasons={seasons} onClick={() => isAllowedToPlayVideo() || experience.isPublic ? setGoToExperience(experience._id) : setShowSubscribeModal(true)} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Category;
